export enum StorageKeys {
  LOCALE = "locale",
  TOKEN = "access-token",
}

export const CREDENTIALS: SelectorItem[] = [
  {
    text: "credentials.individual",
    code: "1.2.398.3.3.4.1.1",
  },
  {
    text: "credentials.legal",
    code: "1.2.398.3.3.4.1.2",
  },
  {
    text: "credentials.first-leader",
    code: "1.2.398.3.3.4.1.2.1",
  },
  {
    text: "credentials.signer",
    code: "1.2.398.3.3.4.1.2.2",
  },
  {
    text: "credentials.financial-signer",
    code: "1.2.398.3.3.4.1.2.3",
  },
  {
    text: "credentials.hr",
    code: "1.2.398.3.3.4.1.2.4",
  },
  {
    text: "credentials.employee",
    code: "1.2.398.3.3.4.1.2.5",
  },
];

export const TYPES_OF_STORAGE: SelectorItem[] = [
  { text: "storages.computer", value: "PKCS12" },
  { text: "storages.kaz-token", value: "AKKaztokenStore" },
  { text: "storages.id-card", value: "AKKZIDCardStore" },
  { text: "storages.e-token", value: "AKEToken72KStore" },
  { text: "storages.ak-ja-carta", value: "AKJaCartaStore" },
];

export enum NCALayerStatuses {
  ACTION_CANCELED = "action.canceled",
  STORAGE_EMPTY = "storage.empty",
  NOT_CONNECTED = "notConnected",
}

export const NCALAYER_MESSAGES = {
  [NCALayerStatuses.STORAGE_EMPTY]: "storages.empty-message",
  [NCALayerStatuses.NOT_CONNECTED]: "storages.not-connected-message",
};

export enum NCALayerModes {
  xml = "signXml",
  base64 = "createCMSSignatureFromBase64",
}

export const dataToSign = "tempDataToSign";

export enum ApiErrorMessages {
  NO_SESSION = "invalidSession/sessionNotFound",
  UNAUTHORIZED = "Unauthorized",
}

export enum UserPermissions {
  ACCESS_ORGANIZATION = "accessOrganization",
  ACCESS_ACCEPT = "accessAccept",
  REJECT_RECONCILIATION_ACT = "rejectReconciliationAct",
  SIGN_RECONCILIATION_ACT = "signReconciliationAct",
  REJECT_INVOICE_ACT = "rejectInvoiceAct",
  SIGN_INVOICE_ACT = "signInvoiceAct",
  SHOW_INVOICES = "showInvoice",
  USERS_MANAGEMENT = "userManagement",
}

export enum FileCodes {
  ACCEPT_PDF = 3,
  ACCEPT_XML = 4,
  RECONCILIATION_XML = 2,
  INDICATIONS = 1,
  INVOICE_XML = 5,
}

/**
 * Статусы актов. Сделаны в виде массива, чтобы можно было получить по индексу(с БД приходит индекс)
 * 0 - в ожидании
 * 1 - Подписан
 * 2 - Отклонен
 */
export const ActStatuses = [
  /*0*/ "all",
  /*1*/ "pending",
  /*2*/ "signed",
  /*3*/ "rejected",
];
export const DATE_FORMAT = "YYYY-MM";
